export const normalizeOptions = (options = []) => {
  return options.map((opt) =>
    typeof opt === 'string' || typeof opt === 'number'
      ? { value: opt, label: String(opt) }
      : opt
  );
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Select/utils/selectHelpers.js